import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import {environment} from './../../../../../environments/environment';
import {TareasApiService} from '../../../../service/api/tareas-api.service';
import {TratamientosApiService} from '../../../../service/api/tratamientos-api.service';
import { Component, ViewChild, ElementRef } from '@angular/core';
import {Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {Filtering} from '../../../../service/filtering/filtering';
import {Utils} from '../../../../common/utils';
import {FormCommonApiService} from '../../../../service/api/formcommon-api.service';
import {BaseView} from '../../../base-view';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import {StorageManager} from '../../../../common/storage-manager.class';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import moment, { Moment } from 'moment';
import { MessageService, TreeNode } from 'primeng/api';

import type { OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { TareaFitoModel } from 'src/app/models/tareas/tarea-fito.model';
import { TareasBioModel } from 'src/app/models/tareas/tareas-bio.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { TratamientosModel } from 'src/app/models/tratamientos/tratamientos.model';
import { TratamientoLineaModel } from 'src/app/models/tratamientos/tratamiento-linea.model';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { InputSwitchChangeEvent } from 'primeng/inputswitch';
import SignaturePad from 'signature_pad';
import { FitosanitariosFormDefinition } from './fitosanitarios-form/form-control/form-definition';
import { FitosanitariosEnvironmentDefinition } from './environment-variables';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';

@Component({
    selector: 'app-pulverizacion',
    standalone: false,
    templateUrl: './fitosanitarios.component.html',
    styleUrls: ['./fitosanitarios.component.scss']
})

export class FitosanitariosComponent extends BaseView<TareaFitoModel> implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('passport', {static: true}) passport: ElementRef | undefined;
    @ViewChild('signaturePadElement', { static: true }) signaturePadElementClientes!: SignaturePad;
    @ViewChild('signaturePadElement', { static: true }) signaturePadElementTrabajadores!: SignaturePad;

    public form!: FitosanitariosFormDefinition;
    public env: FitosanitariosEnvironmentDefinition = new FitosanitariosEnvironmentDefinition();
    
    
    public years = [
        {label: '...', value: 0},
    ];
    public selectedYears = 0;
    public allFitoProducts: ProductosModel[] = [];

    public showAllTareas = false;
    public tooltipForce = false;
    public tooltipClass = this.tooltipForce ? 'telegram-passport-tooltip telegram-passport-tooltip-shown' : 'telegram-passport-tooltip';

    public modelSignature: string | null = null;
    public distributionOrderFormTratamientos = [2, 3, 2];

    public rolUser = StorageManager.getUser().rol;
    public hiddenButtonDelete = false;

    public isGeneratingCanvas = false;
    public firmaPath = '';

    public rol = StorageManager.getUser().rol;
    public getRequest: RequestHandler<TareaFitoModel[]> = this.tareasApi.fitosanitariosGET;
    public deleteRequest: RequestHandler<TareaFitoModel> = this.tareasApi.fitosanitariosDELETE;
    public pathToForm = 'crear-fitosanitario';
    public menuItemId = 'fitosanitarios';
    public aplicado = {
        selected: ''
    };
    public validado = {
        selected: ''
    };

    public deleteRequestButtonType: FormType = FormType.DELETION;

    public override canShow: Record<string, boolean> = {};
    public override model: TareaFitoModel = {};

    public showReceta = false;
    public isShowingGlobalGAP = false;
    public receta: TareaFitoModel = {};
    public arrayProdsNom: string[] = [];
    public arrayProdsUds: string[] = [];
    public arrayCantsReceta: number[] = [];
    public arrayUdsMedida: string[] = [];
    public ps = '';
    public currentUser = StorageManager.getUser();
    public clienteSelected = '';
    public telefClienteSelected = '';
    public observaciones = '';
    public empresa = 'Locatec Aplicaciones Informáticas';

    public mostrarTratamientosAplicados = true;
    public override filtering: Filtering<TareaFitoModel> = new Filtering<TareaFitoModel>();
    public currentYear = '';

    public btnAnadir = 'Añadir Tarea';

    public distributionOrder = [4];

    public tareasBio: TareasBioModel[] = [];
    public parcelas: ParcelasModel[] = [];
    public fincas: FincasModel[] = [];
    public parcelasFilter: ParcelasModel[] = [];
    public trabajadores: MantenimientoModel[] = [];
    public trabajadoresFilter: MantenimientoModel[] = [];
    public sm = localStorage.getItem('sm') ? true : false;

    public totalHoras: Moment | string = '00:00';
    public auxTotalHoras: Moment | string = '00:00';

    public cols: ColInterface[] = [
        { 
            field: 'referencia_receta', 
            header: 'Orden', 
            filter: '', 
            visible: this.env.appName === 'pyf' 
        },
        { 
            field: 'id', 
            header: 'Nº\xa0Receta', 
            filter: '', 
            visible: this.env.appName !== 'pyf' && this.env.appName !== 'donjardin' 
        },
        { 
            field: 'fecha_inicio', 
            header: (this.env.appName === 'armentia') ? 'Fecha\xa0ini.' : 'F.\xa0Receta', 
            filter: '',  
            visible: this.env.showFitoFechaReceta && !this.env.showTareasMto 
        },
        { 
            field: 'fecha_fin', 
            header: (this.env.appName === 'armentia') ? 'Fecha\xa0fin' : 'F.\xa0Apl.', 
            filter: '', 
        },
        { 
            field: 'fin_fecha', 
            header: 'Fecha fin', 
            filter: '', 
            visible: this.env.appName === 'fotoagricultura' 
        },
        { 
            field: 'duracion', 
            header: 'Duración', 
            filter: '', 
            visible: this.env.showTareasFitoDuracion 
        },
        { 
            field: 'cliente_nombre', 
            header: this.env.clienteName, 
            filter: '', 
            visible: !this.env.showTareasMto && this.env.hasClients 
        },
        { 
            field: 'finca', 
            header: this.env.fincaName, 
            filter: '', 
            visible: this.env.showTareasFincas 
        },
        {
            field: 'sectores_nombres',
            header: this.env.sectoresName,
            filter: '',
            visible: this.env.showTareasSector && !environment.features.showTareasMto
        },
        { 
            field: 'trabajadores_nombres', 
            header: 'Empleado',
            visible: environment.features.showTareasMto 
        },
        { 
            field: 'hora_inicio', 
            header: 'Hora Inicio',
            visible: environment.features.showTareasMto || environment.features.showTareasFitoHoras 
        },
        { 
            field: 'hora_fin', 
            header: 'Hora Fin', 
            visible: environment.features.showTareasMto || environment.features.showTareasFitoHoras 
        },
        { 
            field: 'horas_totales', 
            header: 'Horas', 
            filter: '', 
            visible: (environment.features.tareasHorasTotales || environment.features.showTareasMto) && this.env.appName !== 'pyf'
        },
        { 
            field: 'parcelas_nombres', 
            header: this.env.parcelasName, 
            filter: '', 
            visible: !environment.features.showTareasMto && this.env.showTareasParcela 
        },
        { 
            field: 'tratamiento_nombre', 
            header: this.env.tareasTratamientosLabel, 
            filter: '', 
            visible: this.env.showTareasTratamientos 
        },
        { 
            field: 'materias_activas', 
            header: 'Materia activa', 
            filter: '', 
            visible: this.env.showTareasMateriaActiva 
        },
        { 
            field: 'productos_nombres', 
            header: 'Nombre comercial', 
            filter: '', 
            visible: this.env.showFitoProductosNombres 
        },
        { 
            field: 'maquinaria', 
            header: 'Maquinaria', 
            filter: '', 
            visible: (!this.env.showTareasMto && this.env.showTareasMaquinaria) && this.env.appName !== 'pyf'
        },
        { 
            field: 'litros', 
            header: this.env.appName === 'onda' ? 'Litros' : 'Litros/' + this.env.textoSuperficie, 
            filter: '', 
        },
        { 
            field: 'lote', 
            header: 'Lote', 
            filter: '', 
            visible: this.env.showTareasFitoLote 
        },
        { 
            field: 'eficacia', 
            header: 'Eficacia', 
            filter: '', 
            visible: this.env.showFitoEficacia && this.env.appName !== 'pyf' && !this.env.showTareasMto 
        },
        { 
            field: 'punto_km_inicio', 
            header: 'Punto Km inicial', 
            filter: '', 
            visible: this.env.showTareasFitoPuntoKm 
        },
        { 
            field: 'punto_km', 
            header: 'Punto Km final', 
            filter: '', 
            visible: this.env.showTareasFitoPuntoKm 
        },
        { 
            field: 'facturado', 
            header: 'Facturado', 
            filter: '', 
            visible: this.env.appName === 'agrosalvi' 
        },
        { 
            field: 'aplicado', 
            header: 'Aplicado', 
            filter: '', 
            visible: this.env.showTareasMto 
        },
        { 
            field: 'nombres_asignados', 
            header: 'Asignador', 
            filter: '', 
            visible: this.env.showAssignUserTasksFitosanitario || this.env.showAssignUserInAllTasks 
        },
    ];
    public arrayProductosTodos: ProductosModel[] = [
        {id: '', nombre: '', materia_activa: '', ps: ''}
    ];

    public arrayTratamientos: TratamientosModel[] = [
        {id: '', ids_productos: '', cantidades_real: ''}
    ];

    public str = '';

    public modalShowCampaign  = false;

    public digitosDecimalesDosis: number = (environment.appName === 'vginer') ? 3 : 2 ;
    public parts: string[] = [];
 

    public fecha: {inicio: string; fin: string} = {
        inicio: '',
        fin: '',
    };


    constructor(public tareasApi: TareasApiService,
        public tratamientosApi: TratamientosApiService,
        private formApi: FormCommonApiService,
        private dashboard: DashboardService,
        private fincasApi: FincasApiService,
        private trabajadoresApi: TrabajadoresApiService,
        private router: Router,
        private messageService: MessageService) {
        super(dashboard, tareasApi.fitosanitariosGET);

    }

    ngOnInit() {
        if (environment.features.showTareasMto){
            if (this.rolUser !== 'admin'){
                this.hiddenButtonDelete = true;
            }
            
        }
        if (this.env.appName === 'ava') {
            this.aplicado.selected = 'no-aplicados';
        }

        this.tareasApi.enviarRecetaCaptura.response(() => {
            if (!this.tareasApi.enviarRecetaCaptura.hasError && this.showReceta) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Email enviado',
                    detail: 'Se ha enviado el impreso de la receta correctamente.'
                });
                this.showReceta = false;
            }
        });

        this.dashboard.setSubmenuItem(this.menuItemId);

        if (this.env.showTareasBio) {
            this.tareasApi.bio.GET.toPromise().then(res => {
                this.tareasBio = res;
                return;
            }).catch (e => {
                console.log('catch en tareasApi: ' + e);
            }
            );
        }

        this.expandFormFields();

        this.env.appName = environment.appName;
        this.clienteSelected = '';
        if (StorageManager.getClient()) {
            this.clienteSelected = StorageManager.getClient().nombre;
            this.telefClienteSelected = StorageManager.getClient().telefono;
        }

        if (this.env.empresaName !== '') {
            this.empresa = this.env.empresaName;
        }

        if (this.env.appName === 'melia') {
            this.empresa = this.currentUser.apellidos;
        }

        this.filtering.addFilter((copy: TreeNode<TareaFitoModel>[] | void) => (copy as TreeNode<TareaFitoModel>[]).filter(row => {
            const tareaFito = row as TareaFitoModel;

            switch (this.aplicado.selected) {
            case 'aplicados':
                return [true, '1', 1].includes(tareaFito.aplicado ?? '');
            case 'no-aplicados':
                return [null, undefined, '0', 0].includes(tareaFito.aplicado?.toString() ?? '');
            default:
                return true;
            }
        }));

        if ( this.env.showCampaign ) {
            this.fillCampaign();
            this.filtering.addFilter((copy: TreeNode<TareaFitoModel>[] | void) => (copy as TreeNode<TareaFitoModel>[]).filter(row => {
                if ( this.selectedYears === 0 ){
                    return true;
                } else {
                    return this.compareDates(row);
                }
            }));
        }
       

        if (this.env.showFitoValidado) {
            this.filtering.addFilter((copy: TreeNode<TareaFitoModel>[] | void) => (copy as TreeNode<TareaFitoModel>[]).filter(row => {
                const tareaFito = row.data as TareaFitoModel;

                switch (this.validado.selected) {
                case 'validados':
                    return [true, '1', 1].includes(tareaFito.validado ?? '');
                case 'no-validados':
                    return [null, undefined, '0', 0].includes(tareaFito.validado?.toString() ?? '');
                default:
                    return true;
                }
            }));
        }

        this.filtering.addFilter((data: TreeNode<TareaFitoModel>[] | void) => (data as TreeNode<TareaFitoModel>[]).sort((a, b) =>
            parseInt(a.data?.id ?? '', 10) > parseInt(b.data?.id ?? '', 10) ? -1 : 1
        ));


        this.arrayProductosTodos = [];
        this.formApi.productos.safePerform();
        this.formApi.productos.response(data2 => {
            this.arrayProductosTodos = [];
            data2.forEach((element: ProductosModel) => {
                if (element) {
                    this.arrayProductosTodos.push(
                        {
                            id: element.id ?? '', 
                            nombre: element.nombre, 
                            materia_activa: element.materia_activa, 
                            ps: element.ps, 
                            uds: element.unidades
                        }
                    );
                }
            });
        });

        this.fincasApi.fincasGET.safePerform();
        this.fincasApi.fincasGET.response(fincas => {
            this.fincas = fincas;
        });

        this.fincasApi.parcelasGET.safePerform();
        this.fincasApi.parcelasGET.response(parcelas => {
            this.parcelas = parcelas;
        });

        this.trabajadoresApi.trabajadoresGET.safePerform();
        this.trabajadoresApi.trabajadoresGET.response(trabajadores => {
            this.trabajadores = trabajadores;
        });
        

        this.arrayTratamientos = [];
        this.tratamientosApi.tratamientosGET.safePerform();
        this.tratamientosApi.tratamientosGET.response(data3 => {
            this.arrayTratamientos = [];
            data3.forEach((element2: TratamientosModel) => {
                
                if (element2.id && element2.ids_productos) {
                    this.arrayTratamientos.push(
                        {
                            id: element2.id,
                            ids_productos: element2.ids_productos,
                            cantidades_real: this.sm ? element2.cantidades_cuaderno ?? '' : element2.cantidades_real ?? ''
                        }
                    );
                }
            });
        });

        if (environment.features.showTareasMto) {
            /*** 
            *  En el caso de que el usuario no se admin,
            * filtrará por su id de usuario que coincide,
            *  con el id trabajador   
            */
            if (StorageManager.getUser().rol !== 'admin') {
                this.filtering.addFilter((copy: TreeNode<TareaFitoModel>[] | void) => (copy as TreeNode<TareaFitoModel>[]).filter(row => {
                    const tareaFito = row.data as TareaFitoModel;

                    if (tareaFito.ids_trabajadores != null) {

                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaFito.ids_trabajadores as string).split(';');
                        if (listaTrabajadores.includes(idTrabajador)) {
                            return true;
                        }

                    }
                    return false;
                }));
            }

            /*** 
            *  Fin de filtrar por id_usuario = trabajador,
            *   
           */
            this.filtering.addFilter((copy: TreeNode<TareaFitoModel>[] | void) => (copy as TreeNode<TareaFitoModel>[]).filter(row => {
                const tareaFito = row as TareaFitoModel;

                if (this.fecha.inicio && this.fecha.fin ) {
                    if (tareaFito.fecha_fin == null ){
                        return false;
                    } else {
                        const arrayFecha = tareaFito.fecha_fin.split('/');
                        const fechaAux = arrayFecha[2] + '-' + arrayFecha[1] + '-' + arrayFecha[0];
              
                        if (
                            (moment(moment(this.fecha.inicio).format('YYYY-MM-DD')).diff(fechaAux) <= 0) && 
                            (moment(moment(this.fecha.fin).format('YYYY-MM-DD')).diff(fechaAux) >= 0)
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    
                } else {
                    return true;
                }
            }));
        }

        /**
             *  Activado la asignacion de usuarios en la tabla tareas
             *  Filtraremos las tareas si en caso de que el usuario se encuentre como asignado en la tarea
             */
        // if (environment.features.showAssignUserTasksFertilizante || environment.features.showAssignUserInAllTasks) {
        if (this.env.appName === 'ava') {
            /** Solo el que tiene el rol de admin podra ver todas las tareas */
            if (StorageManager.getUser().rol !== 'admin') {
                this.filtering.addFilter((copy: TreeNode<TareaFitoModel>[] | void) => (copy as TreeNode<TareaFitoModel>[]).filter(row => {
                    const tareaFito = row.data as TareaFitoModel;

                    if (tareaFito.referencia_usuario != null) {

                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = tareaFito.referencia_usuario.split(';');
                        if (listaTrabajadores.includes(idTrabajador)) {
                            return true;
                        }
                    }
                    return false;
                }));
            }
        }// Fin filtro asignados
    }

    ngAfterViewInit() {
        this.tareasApi.fitosanitariosGET.response(() => {
            this.updateFooter();
            this.sum();
        });
    }

    getFechaInicio( event: string) {
        this.fecha.inicio = event;
        this.filtering.filter();
        this.updateFooter();
        
    }
    getFechaFin( event: string) {
        this.fecha.fin = event;
        this.filtering.filter();
        this.updateFooter();
    }

    formatParcelas() {
        let parcelasId: string[];
        this.model.parcelas_superficie = 0;
        if (this.model.ids_parcelas) {
            parcelasId = this.model.ids_parcelas.split(';') || [];
        } else {
            parcelasId = [];
        }
        this.parcelasFilter = [];
        if (parcelasId.length > 0) {
            this.parcelas.forEach(parcela => {
                if (parcelasId.includes(parcela.id.toString())) {
                    this.parcelasFilter.push(parcela);
                }
            });
            this.model.parcelas = [];
            this.parcelasFilter.forEach(parcela => {
                if (parcela && this.model.parcelas_superficie !== undefined) {
                    this.model.parcelas?.push(parcela);
                    this.model.parcelas_superficie += parseFloat(parcela.superficie_cultivada || '0.00');
                }
            });
            this.model.parcelas_superficie = +this.model.parcelas_superficie.toFixed(2);
        } else {
            this.model.parcelas = [];
        }
    }

    decode(utftext: string) {
        let string = '', i = 0, c = 0, c2 = 0, c3 = 0;

        while (i < utftext.length) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                // eslint-disable-next-line no-bitwise
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                // eslint-disable-next-line no-bitwise
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }

        return string;
    }

    modalCampaign() {
        this.modalShowCampaign = true;
    }

    closeModalShowCampaign() {
        this.modalShowCampaign = false;
    }

    selectedCampaign(){
        this.filtering.filter();
    }

    compareDates( row: TreeNode<TareaFitoModel> ) {
        const tareaFito = row as TareaFitoModel;
        const year = tareaFito.fecha_inicio?.toString().split('/')[2] ?? '';
        return (year === ('20' + this.selectedYears));
    }
    
    /**
     *  Rellena el listado de campañas
     */
    fillCampaign () {
        const fechaActual = new Date().getFullYear();
        let fechaDosDigitos = 0;
        
        for (let index = 2020; index <= fechaActual; index++) {
            fechaDosDigitos = parseInt( (index.toString()).substring(2, 4) , 10);
            this.years.push({ 
                label: environment.features.applicationType === 'cropgest' ? 
                    index.toString() : 
                    (index.toString() + '-' + (fechaDosDigitos + 1 ).toString()), 
                value: fechaDosDigitos 
            });
            
        }
    }
    
    public filtrarTratamientos(value: string, from = 'switch_aplicados') {
        if (from === 'switch_aplicados') {
            this.aplicado.selected = this.aplicado.selected === value ? '' : value;
        } else if (from === 'switch_validados') {
            if (this.env.showFitoValidado) {
                this.validado.selected = this.validado.selected === value ? '' : value;
            }
        }

        this.filtering.filter();
        if (['donjardin', 'coliberica', 'fotoagricultura'].includes(this.env.appName) ){
            this.sum();
        }
    }

    public add() {
        if (this.env.hasClients && !StorageManager.getClient() && this.env.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', this.pathToForm]);
        }
    }

    public edit(data: TareaFitoModel) {
        this.router.navigate(['dashboard', 'editar-fitosanitario', data.id, data]);
    }

    public duplicate(data: TareaFitoModel) {
        this.router.navigate(['dashboard', 'duplicar-fitosanitario', data.id, data]);
    }

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public override show(modal: string, data: TareaFitoModel) {
        super.show(modal, data);

        this.formatParcelas();

        if (this.model.tratamiento) {
            this.model.tratamiento.linea?.forEach((it: TratamientoLineaModel) => {
                const diff = moment(new Date()).diff(Utils.toDate(it.producto.fecha_caducidad ?? ''), 'months');
                const diff2 = moment(new Date()).diff(Utils.toDate(it.producto.fecha_caducidad ?? ''), 'days');
    
                if (diff >= 12) {
                    it.producto.caducado = '#222222';
                } else if (diff >= 6) {
                    it.producto.caducado = '#ff7f7f';
                } else if (diff >= 0) {
                    if ((diff === 0) && diff2 < 0) {
                        it.producto.caducado = '#f8f9fa';
                    } else {
                        it.producto.caducado = '#ffcf78';
                    }
                } else {
                    it.producto.caducado = '#f8f9fa';
                }
            });
        }
        
        this.form = new FitosanitariosFormDefinition(+FormType.INFORMATIVE, data as Record<string,string>, this.appendTable(data));
    }

    public override hide(modal: string) {
        this.model = {};
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    public override ngOnDestroy() {
        Utils.unsuscribe([
            this.tareasApi.fitosanitariosGET,
        ]);
        Utils.unsuscribe([
            this.tareasApi.fitosanitariosDELETE,
        ]);
        Utils.unsuscribe([
            this.tratamientosApi.tratamientosGET,
        ]);
        Utils.unsuscribe([
            this.formApi.productos
        ]);
    }

    public enviarCorreo() {
        this.isGeneratingCanvas = true;
        const config = this.getPrintConfig();

        html2canvas(
            document.getElementById('html2canvasDiv') ?? new HTMLElement(), 
            {scale: config.canvasScale, logging: false}
        ).then(canvas => {
            this.isGeneratingCanvas = false;
            const pdf = new jsPDF(config.orientation, 'mm', 'a4');
            const data = canvas.toDataURL('image/png');

            if (canvas.width > canvas.height) {
                pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)), 'alias', 'FAST');
            } else {
                pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height, 'alias', 'FAST');
            }

            const adjunto = encodeURIComponent(window.btoa(pdf.output()));

            let email = '';
            if (this.receta.finca_asociada && this.receta.finca_asociada.email) {
                email = this.receta.finca_asociada.email;
            } else if (this.receta.cliente_email) {
                email = this.receta.cliente_email;
            } else {
                email = '';
            }

            if (email !== '') {
                this.tareasApi.enviarRecetaCaptura.perform({
                    email,
                    generado: adjunto,
                    finca: this.receta.finca,
                    parcelas: this.receta.parcelas_nombres,
                    tratamiento: this.receta.tratamiento_nombre,
                } as never);
                if (this.env.appName === 'pascualcabedo') {
                    this.tareasApi.enviarRecetaCaptura.perform({
                        email: 'pascualcabedo@pascualcabedo.es',
                        generado: adjunto,
                        finca: this.receta.finca,
                        tratamiento: this.receta.tratamiento_nombre,
                    } as never);
                    this.tareasApi.enviarRecetaCaptura.perform({
                        email: 'mariajose@pascualcabedo.es',
                        generado: adjunto,
                        finca: this.receta.finca,
                        tratamiento: this.receta.tratamiento_nombre,
                    } as never);
                }
                if (this.env.appName === 'saviatropical') {
                    this.tareasApi.enviarRecetaCaptura.perform({
                        email: 'saviatropical@gmail.com',
                        generado: adjunto,
                        finca: this.receta.finca,
                        tratamiento: this.receta.tratamiento_nombre,
                    } as never);
                }
                if (this.env.appName === 'esparragosgranada') {
                    switch (this.receta.cliente?.cooperativa) {
                    case 'AGROMESIA SCA':
                        this.tareasApi.enviarRecetaCaptura.perform({
                            email: 'agromesia@wanadoo.es',
                            generado: adjunto,
                            finca: this.receta.finca,
                            tratamiento: this.receta.tratamiento_nombre,
                        } as never);
                        break;
                    case 'ESPAFRON SCA':
                        this.tareasApi.enviarRecetaCaptura.perform({
                            email: 'espafron.s.c.a@gmail.com',
                            generado: adjunto,
                            finca: this.receta.finca,
                            tratamiento: this.receta.tratamiento_nombre,
                        } as never);
                        break;
                    case 'ESPALORQUIANA SCA':
                        this.tareasApi.enviarRecetaCaptura.perform({
                            email: 'espalorquianagranada@hotmail.com',
                            generado: adjunto,
                            finca: this.receta.finca,
                            tratamiento: this.receta.tratamiento_nombre,
                        } as never);
                        break;
                    case 'VEGACHAUCHINA SCA':
                        this.tareasApi.enviarRecetaCaptura.perform({
                            email: 'pilargranadaesp@hotmail.com',
                            generado: adjunto,
                            finca: this.receta.finca,
                            tratamiento: this.receta.tratamiento_nombre,
                        } as never);
                        break;
                    default:
                        break;
                    }
                    this.tareasApi.enviarRecetaCaptura.perform({
                        email: 'alipioa@esparragosgranada.es',
                        generado: adjunto,
                        finca: this.receta.finca,
                        tratamiento: this.receta.tratamiento_nombre,
                    } as never);
                    this.tareasApi.enviarRecetaCaptura.perform({
                        email: 'tecnico@esparragosgranada.es',
                        generado: adjunto,
                        finca: this.receta.finca,
                        tratamiento: this.receta.tratamiento_nombre,
                    } as never);
                }
            } else {
                this.tareasApi.enviarRecetaCaptura.hasError = true;
                this.tareasApi.enviarRecetaCaptura['error'] = 'El cliente o finca no tiene un email asociado';
            }
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        ).then(() => {
            alert('Ha habido un error al enviar el email. Si este error persiste, por favor, contacte con un administrador.');
            // console.log(error);

            this.isGeneratingCanvas = false;
            this.tareasApi.enviarRecetaCaptura.hasError = true;
            this.tareasApi.enviarRecetaCaptura['error'] = 'Error al enviar email';
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }


    public enviarWhatsapp() {
        html2canvas(document.getElementById('html2canvasDiv') ?? new HTMLElement()).then(canvas => {
            canvas.toBlob(blob => {
                const formData = new FormData();
                formData.append('image', blob ?? new Blob(), 'receta.png');
        
                fetch('https://whatsappbot.sgdocs.com/upload_file.php', {
                    method: 'POST',
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        const publicImageUrl = data.url;
        
                        // Enviem la URL cap a n8n perquè la passe a WhatsApp
                        fetch('https://n8n.locatec-ai.es/webhook/78dd0e86-bda3-465b-a50f-d66d71ba4596', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                imageUrl: publicImageUrl,
                                phoneNumber:  '+34' + this.receta.cliente_telefono,
                                clientName: this.receta.cliente_nombre ?? '',
                                fincaName: this.receta.finca_asociada?.nombre ?? ''
                            })
                        });
                        return;
                    }).catch (e => {
                        console.log('catch en getPosition: ' + e);
                    });
            }, 'image/png');
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );

        //this.showReceta = false;
    }

    public generarReceta(data: TareaFitoModel, showAfter = true) {
        this.tareasApi.enviarRecetaCaptura.hasError = false;
        this.tareasApi.enviarRecetaCaptura['error'] = null;

        this.receta = data;
        
        this.currentYear = new Date().getFullYear().toString();
        this.receta.fecha_completa = moment(this.receta.fecha_fin, 'DD/MM/YYYY').isValid()
            ? moment(this.receta.fecha_fin, 'DD/MM/YYYY').format('LL')
            : '___/___/______';

        // Vicente Giner
        this.receta.fecha_hoy = moment().format('LL');
        if (this.receta.fecha_fin) {
            const fechaAplicacionParts = this.receta.fecha_fin.split('/');
            this.receta.fecha_objeto = {
                dia: parseInt(fechaAplicacionParts[0] ?? '', 10),
                mes: parseInt(fechaAplicacionParts[1] ?? '', 10),
                anyo: fechaAplicacionParts[2] ?? ''
            };
        }
        if (this.receta.fecha_inicio) {
            const mes = moment(this.receta.fecha_inicio, 'DD/MM/YYYY').get('month');
            const anyo = moment(this.receta.fecha_inicio, 'DD/MM/YYYY').get('year');
            this.receta.campanya_citricola = (mes >= 8) ? (anyo + '/' + (anyo + 1)) : ((anyo - 1) + '/' + anyo);
        }

        this.receta.anyo = this.receta.fecha_fin ? moment(this.receta.fecha_fin, 'DD/MM/YYYY').year() : 0;
        this.receta.finca_asociada = this.fincas.find(it => it.id === this.receta.id_finca) ?? {} as FincasModel;
        
        if (this.env.appName === 'laplana'){
            this.receta.finca_localidad = this.receta.finca_asociada.localidad ?? '';
        }
        this.receta.cliente_nif = (data.cliente || {}).nif ?? '';
        this.receta.cliente_telefono = data.cliente_telefono ?? '';
        this.receta.usuario_nombre = '';
        if (this.currentUser.apellidos == null){
            this.currentUser.apellidos = '';
        }
        if (this.currentUser) {
            this.receta.usuario_nombre = this.currentUser.nombre + ' ' + this.currentUser.apellidos;
            this.receta.usuario_firma = this.currentUser.firma ?? '';
        }
        this.receta.usuario_nif = this.currentUser.nif ?? '';
        this.receta.usuario_ropo = this.currentUser.ropo ?? '';

        /*** OBTENER NOMBRE Y VARIEDAD DE LA PARCELA ***/
        // SIMAT
        let parcelasId: string[] = [];
        this.receta.superficie_parcelas = 0;
        this.receta.variedades = [];

        if (this.receta.ids_parcelas) {
            if (this.receta.ids_parcelas) {
                parcelasId = this.receta.ids_parcelas.split(';') || [];
            } else {
                parcelasId = [];
            }
            this.parcelasFilter = [];
    
            if (parcelasId.length > 0) {
                this.parcelas.forEach(parcela => {
                    if (parcelasId.includes(parcela.id.toString()) && this.receta.superficie_parcelas !== undefined) {
                        this.parcelasFilter.push(parcela);
                        this.receta.superficie_parcelas += parseFloat((parcela.superficie_cultivada || '').replace(',', '.') || '0.00');
                        if (!this.receta.variedades?.includes(parcela.variedad ?? '')) {
                            this.receta.variedades?.push(parcela.variedad ?? '');
                        }
                    }
                });
                this.receta.superficie_parcelas = +this.receta.superficie_parcelas.toFixed(2);
    
                this.receta.parcelas = this.parcelasFilter;
            } else {
                this.receta.parcelas = [];
            }
        }

        this.receta.caldo_aplicado = 
            parseFloat(this.receta.litros?.toString() ?? '') * parseFloat(this.receta.superficie_parcelas.toString() ?? '');
        if ([NaN, Infinity].includes(this.receta.caldo_aplicado)) {
            this.receta.caldo_aplicado = 0;
        }
        this.receta.litros_aplicados_ha = 
            parseFloat(this.receta.litros?.toString() ?? '') * parseFloat(this.receta.superficie_parcelas.toString() ?? '');
        if ([NaN, Infinity].includes(this.receta.litros_aplicados_ha)) {
            this.receta.litros_aplicados_ha = 0;
        }

        // LA FAST
        if (this.env.showTareasBio) {
            this.receta.bios = [];
            this.tareasBio.forEach(bio => {
                if (
                    bio.id_sector === this.receta.id_sector &&
                    parcelasId.includes(bio.ids_parcelas ?? '')
                ) {
                    bio.fecha_aplicacion = moment(bio.fecha_aplicacion, 'YYYY-MM-DD').format('DD/MM/YYYY');
                    this.receta.bios?.push(bio);
                }
            });
        }

        /***********************************************/

        // SIMAT
        moment.locale('es');
        this.receta.ropo = this.currentUser.ropo || '';
        
        // arrayProds
        this.str = 'ú';
        this.str = this.decode(this.str);

        this.arrayProdsNom = [];
        this.arrayProdsUds = [];
        this.arrayCantsReceta = [];

        const idTratamiento = data.id_tratamiento;
        let productosTratamiento = '';
        let cantidadesTratamiento = '';

        for (const tratamiento of this.arrayTratamientos) {
            if (tratamiento.id === idTratamiento) {

                productosTratamiento = tratamiento.ids_productos ?? '';
                cantidadesTratamiento =  tratamiento.cantidades_real ?? '';
            }
        }

        const arrayProdsReceta = (productosTratamiento || '').split(';');
        this.arrayCantsReceta = (cantidadesTratamiento || '').split(';').map(Number);
        this.ps = '';

        for (let j = 0; j < arrayProdsReceta.length; j++) {
            for (const producto of this.arrayProductosTodos) {
                if (producto.id === arrayProdsReceta[j]) {
                    this.arrayProdsNom[j] = producto.nombre ?? '';
                    this.arrayProdsUds[j] = producto.uds ?? '';
                    if (
                        ![
                            'oliverfutur', 
                            'melia', 
                            'ebro', 
                            'torrepacheco', 
                            'lacooperativa', 
                            'covidai', 
                            'ferticinca', 
                            'agricar'
                        ].includes(this.env.appName)
                    ) {
                        this.arrayCantsReceta[j] = +(((this.arrayCantsReceta[j] || 0) * (this.receta.litros || 0)) / 100).toFixed(2);
                    }
 
                    if (this.env.appName === 'ferticinca') {
                        this.arrayCantsReceta[j] = +(
                            ((this.arrayCantsReceta[j] || 0) * (this.receta.superficie_parcelas || 0)) / 100
                        ).toFixed(2);
                    }
 
                    if (producto.ps !== undefined && producto.ps > this.ps) {
                        this.ps = producto.ps;
                    }

                    if (this.arrayCantsReceta[j] && (this.arrayCantsReceta[j] || 0) < 1) {
                        if (
                            ![
                                'oliverfutur', 
                                'melia', 
                                'ebro', 
                                'torrepacheco', 
                                'lacooperativa', 
                                'covidai', 
                                'agricar'
                            ].includes(this.env.appName)) {
                            this.arrayCantsReceta[j] = +((this.arrayCantsReceta[j] || 0) * 1000).toFixed(2);
                        }
                        if (this.arrayProdsUds[j] === 'Litros') {
                            this.arrayUdsMedida[j] = 'c.c.';
                        } else {
                            this.arrayUdsMedida[j] = 'gr.';
                        }
                    } else {
                        if (this.arrayProdsUds[j] === 'Litros') {
                            this.arrayUdsMedida[j] = 'Litros';
                        } else {
                            this.arrayUdsMedida[j] = 'Kilos';
                        }

                    }
                                       
                }
            }
        }

        this.parts = [];
        // En la nueva versión, `uds_medida` viene siempre del Tratamiento
        this.parts = (this.receta.tratamiento?.uds_medida || '').split(';');

        let k = 0;
        this.receta.tratamiento?.linea?.map((it: TratamientoLineaModel) => {
            if (it.producto) {
                it.producto.unidades = this.parts[k++];
            }
        });

        // HERNANDORENA
        if (this.env.showRegistroHernandorena && this.receta.tratamiento) {
            this.receta.agentes = (this.receta.tratamiento.nombres_agentes || '').split(';');
        }

        if ((this.env.appName === 'agromainsa') || (this.env.appName === 'fitogest')) {
            this.observaciones = this.receta.observaciones ?? '';
        }

        if (this.env.showRecetaFirmas) {

            if (this.env.showUsuariosFirma) {
                this.firmaPath = this.pathToFirmas + '_usuarios/' + this.receta.id_usuario + '.png';
            
                if (this.receta.usuario_firma !== '') {
                    this.firmaPath = this.pathToFirmas + '_asesor/' + this.receta.usuario_firma;
                }
            }
            /*if (this.showTrabajadoresFirma) {
                const id_trabajador = (this.receta.ids_trabajadores || '').split(';');
                fetch(this.pathToFirmas + '_trabajadores/' + id_trabajador + '.png').then(res => {
                    if (res.status === 200) {
                        res.blob().then(blob => {
                            this.spTrabajadores.fromDataURL(urlCreator.createObjectURL(blob));
                        });
                    }
                });
            }*/
        }

        // VICENTE GINER
        if (this.env.showRecetaVGiner) {
            this.receta.cubeto_evaporacion = [1, '1', true, 'true'].includes(this.receta.cubeto_evaporacion?.toString() ?? '');
            this.receta.punto_carga = [1, '1', true, 'true'].includes(this.receta.punto_carga?.toString() ?? '');
        }

        if (showAfter) {
            this.showReceta = true;
        }
    }

    public generarGlobalGAP(data: TareaFitoModel) {
        this.generarReceta(data, false);

        if (this.env.showUsuariosFirma) {
            this.firmaPath = this.pathToFirmas + '_usuarios/' + this.receta.id_usuario + '.png';
            
            if (this.receta.usuario_firma !== '') {
                this.firmaPath = this.pathToFirmas + '_asesor/' + this.receta.usuario_firma;
            }
        }

        this.isShowingGlobalGAP = true;
    }

    public getPrintConfig() {
        const config: {canvasScale: number; orientation: 'p' | 'l'; width: number; height: number} = {
            canvasScale: 2,
            orientation: 'p',
            width: 210,
            height: 290
        };
        // Si se está mostrando el documento Global GAP en vez de la receta normal, no se cambia la configuración.
        // if (this.isShowingGlobalGAP) {
        //     return {
        //         canvasScale: 2,
        //         orientation: 'l',
        //         width: 210,
        //         height: 290
        //     };
        // }
        
        switch (this.env.appName) {
        case 'laplana':
            config.canvasScale = 1.04;
            config.width = 197;
            config.height = 290;
            break;
        case 'pascualcabedo':
            config.canvasScale = 0.86;
            break;
        case 'vginer':
            config.orientation = 'l';
            config.width = 290;
            config.height = 210;
            break;
        case 'esparragosgranada':
            config.orientation = 'l';
            config.width = 290;
            config.height = 187;
            break;
        case 'fitogest':
            config.orientation = 'l';
            config.width = 290;
            config.height = 210;
            break;
        case 'agrogest':
            config.orientation = 'l';
            config.width = 290;
            config.height = 210;
            break;
        case 'armentia':
            config.orientation = 'l';
            config.width = 290;
            config.height = 210;
            break;
        case 'melia':
            config.width = 210;   
            break;
        case 'saviatropical':
            config.orientation = 'l';
            config.width = 290;
            config.height = 210;
            break;
        case 'gragon':
            config.orientation = 'l';
            config.width = 290;
            config.height = 210;
            break;
        case 'mbcpomelos':
            config.orientation = 'l';
            config.width = 270;
            break;
        default:
            break;
        }
        return config;
    }

    public imprimirReceta() {
        // let o;
        // let fileName = '';
        // fileName = this.clienteSelected;
        // if (fileName == null) {
        //     fileName = '';
        // }

        // if (this.appName !== 'oliverfutur') {
        //     o = {
        //         filename: 'receta_' + fileName.replace('.', '') + this.receta.id + '.doc',
        //         area: 'div.googoose',
        //         display: 'Print',
        //         lang: 'es-ES',
        //         download: true
        //     };
        // }

        // if (this.appName === 'oliverfutur') {
        //     o = {
        //         filename: 'receta_' + fileName.replace('.', '') + this.receta.id + '.doc',
        //         area: 'div.googoose',
        //         margins: '0.5in',
        //         headermargin: '0.5in',
        //         display: 'Print',
        //         lang: 'es-ES',
        //         download: true
        //     };
        // }

        /** Habilitar para permitir descargar la receta en formato 'doc'. */
        // if (this.showRecetaTratamiento) {
        //     $(document).googoose(o);
        // } else {
        this.isGeneratingCanvas = true;
        const config = this.getPrintConfig();

        html2canvas(
            document.getElementById('html2canvasDiv') ?? new HTMLElement(), 
            {scale: config.canvasScale, logging: false}
        ).then(canvas => {
            this.isGeneratingCanvas = false;
            
            const pdf = new jsPDF(config.orientation, 'mm', 'a4');
            const data = canvas.toDataURL('image/png');
                
            if (canvas.width > canvas.height) {
                if ( this.env.appName === 'pyf' ) {
                    pdf.addImage(data, 'png', 0, 20, 200, 140 , 'alias', undefined);
                } else {
                    pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)), 'alias', 'FAST');
                }
            } else {
                if ( this.env.appName === 'pyf' ) {
                    pdf.addImage(data, 'png', 0, 20, 200, 140 , 'alias', undefined);
                } else {
                    pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height, 'alias', 'FAST');
                }
                   
            }
            pdf.save((this.receta.tratamiento_nombre || '.').replaceAll('.', '_') + '_ '
                    + (this.receta.finca || '.').replaceAll('.', '_'));
            return;
        }).catch (e => {
            console.log('catch en html2canvas: ' + e);
        }
        );
    }

    public enviarTelegram() {
        const idTelegram = StorageManager.getUser().id_telegram;

        if (!idTelegram) {
            const elementPassport = this.passport?.nativeElement;
    
            const passport = document.createElement('script');
            const key = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA72n4YZpEZfgholYLVavB
mtDw3uLgHHxg6Ed6HdNipVPt8pvI+PqFlBlg3Bkpkz+Mxh5GOLy45aF/5AIqk/6A
qk1C5h9j7kgKyAWVlGDvkDiF+CBSrTTdw3CJRog+d1Vm6bvGk7SsUK//aO79u5Fc
9hsidWP0C4ngkK2lOX0+xK/DreZqlSYjt0BecYTV+ldI+Bys5D1TI6365N1SniHB
DjHddB/7DCreFB+MD+ZMcMDq6H59B2kNmI8TI7SHKk3q6x60HajsHXnQBuqm2y5E
TuC1fnwt9yxpLXOTHXxGL0fTuqlv847pLvpBCsZvpug4Zckn/N14hbho9JTbYwD0
fwIDAQAB
-----END PUBLIC KEY-----`;

            const authButton = document.getElementById('telegram_passport_auth');
            passport.text = `var auth_button = document.getElementById('telegram_passport_auth');
            var auth_params = {
              bot_id:        6449999161,
              scope:         {data: [{type: 'id_document', selfie: true}, 'address_document', 'phone_number', 'email'], v: 1},
              public_key:    ` + '`' + key + '`' + `,
              nonce:         '${environment.serverUrl}',
              callback_url:  '${environment.serverUrl}#/dashboard/fitosanitarios'
            };
            auth_button.addEventListener('click', function() {            
                Telegram.Passport.auth(auth_params, function(show) {
                    if (show) {
                        
                    } else {
                        
                    }
                });
            }
            , false);`;
    
            elementPassport.parentElement.replaceChild(passport, elementPassport);      
    
            authButton?.click();
            this.tooltipForce = true;
            this.tooltipClass = this.tooltipForce ? 
                'telegram-passport-tooltip telegram-passport-tooltip-shown' : 
                'telegram-passport-tooltip';
        } else {

            this.isGeneratingCanvas = true;
            const config = this.getPrintConfig();
    
            html2canvas(
                document.getElementById('html2canvasDiv') ?? new HTMLElement, 
                {scale: config.canvasScale, logging: false}
            ).then(canvas => {
                this.isGeneratingCanvas = false;
                    
                const pdf = new jsPDF(config.orientation, 'mm', 'a4');
                const data = canvas.toDataURL('image/png');
                        
                if (canvas.width > canvas.height) {
                    if ( this.env.appName === 'pyf' ) {
                        pdf.addImage(data, 'png', 0, 20, 200, 140 , 'alias', undefined);
                    } else {
                        pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)), 'alias', 'FAST');
                    }
                } else {
                    if ( this.env.appName === 'pyf' ) {
                        pdf.addImage(data, 'png', 0, 20, 200, 140 , 'alias', undefined);
                    } else {
                        pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height, 'alias', 'FAST');
                    }           
                }
    
                const blob = pdf.output('blob');
                const file = new File([blob], 'receta.pdf');
                    
                const tg = {
                    token: '6449999161:AAFpVGCLY2bF4NAOs98mU4Brw7KVI9hZRBY',
                    chat_id: StorageManager.getUser().id_telegram
                };
                        
                const formData = new FormData();
                formData.append('document', file, 'receta.pdf');
    
                function sendDocument() {
                    const url = `https://api.telegram.org/bot${tg.token}/sendDocument?chat_id=${tg.chat_id}`;
                    const xht = new XMLHttpRequest();
    
                    xht.open('POST', url);
                    xht.send(formData);
                }
    
                sendDocument();
                return;
            }).catch (e => {
                console.log('catch en htmlCanvas: ' + e);
            }
            );
        }
    }

    public globalConditionalStyle(
        value: string, 
        col: ColInterface, 
        _colGroup: ColInterface[], 
        row: TreeNode<TareaFitoModel>
    ): ColStylesInterface {
        const tareaFito = row.data as TareaFitoModel;
        let estiloVademecum: ColStylesInterface = {};

        if (col.field === 'trabajadores_nombres') {
            return {
                style: {
                    'max-width': '50px',
                }
            };
        }
        if (col.field === 'observaciones') {
            return {
                style: {
                    'max-width': '50px',
                }
            };
        }

        if (environment.features.showTareasMto){
            if (col.field === 'aplicado') {
            
                if (value === '0') {
                    return {
                        rowStyle: {
                            backgroundColor: '#f44242',
                        }
                    };
                }
                else if (value === '1') {
                    return {
                        rowStyle: {
                            backgroundColor: '#00ff00'
                        }
                    };
                }
            }}

        // if (Utils.isNumber(value) && col.field !== 'sector' && col.field !== 'facturado') {
        if (col.field !== 'sector' && col.field !== 'facturado') {
            if (col.field === 'id' || col.field === 'horas_totales') {
                return {textAlign: 'center'};
            } else {
                return {textAlign: 'right', paddingRight: '40px'};
            }

        }

        if (['id', 'fecha_inicio', 'fecha_fin'].includes(col.field)) {
            return {textAlign: 'center'};
        }
        
        if (tareaFito.fecha_caducidad) {
            estiloVademecum = {
                rowStyle: {
                    color: 'black',
                    backgroundColor:  '#ffffff',
                    borderBottom: '1px solid #dddddd'
                },
                textAlign: 'center'
            };

            const diff = moment(new Date()).diff(Utils.toDate(tareaFito.fecha_caducidad), 'months');
            const diff2 = moment(new Date()).diff(Utils.toDate(tareaFito.fecha_caducidad), 'days');

            if (diff >= 12) {
                estiloVademecum = {
                    rowStyle: {
                        color: 'white',
                        backgroundColor: '#222222',
                        borderBottom: '1px solid #dddddd'
                    },
                    textAlign: 'center'
                };
            } else if (diff >= 6) {
                estiloVademecum = {
                    rowStyle: {
                        color: 'black',
                        backgroundColor: '#ff7f7f',
                        borderBottom: '1px solid #dddddd'
                    },
                    textAlign: 'center'
                };
            } else if (diff >= 0) {
                if ((diff === 0) && (diff2 < 0)) {
                    estiloVademecum = {
                        rowStyle: {
                            color: 'black',
                            backgroundColor: '#f8f9fa',
                            borderBottom: '1px solid #dddddd'
                        },
                        textAlign: 'center'
                    };
                } else {
                    estiloVademecum = {
                        rowStyle: {
                            color: 'black',
                            backgroundColor: '#ffcf78',
                            borderBottom: '1px solid #dddddd'
                        },
                        textAlign: 'center'
                    };
                }
            }
        }

        // si se supera el maximo de aplicaciones se pone la letra en rojo
        tareaFito.tratamiento?.linea?.forEach(element => {
            if (element.producto.num_maximo_aplicaciones !== 0 && element.producto.num_maximo_aplicaciones != null ){
                if (element.producto.num_maximo_aplicaciones < (element.producto.veces_aplicado || 0)) {
                    if (estiloVademecum.rowStyle) {
                        estiloVademecum.rowStyle.color = 'red';
                    }
                    return estiloVademecum;
                }
            }
            return {};
        }); 


        return estiloVademecum;
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<TareaFitoModel>) {
        const tareaFito = row.data as TareaFitoModel;
        if (col.field === 'aplicado') {
            if (value === '0'){
                return 'No aplicado';
            }else {
                return 'Aplicado';
            }
        }

        if (col.field === 'parcelas_nombres') {
            return (value && value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }
        if (col.field === 'eficacia') {
            switch (value) {
            case '1':
                return 'Buena';
            case '2':
                return 'Regular';
            case '3':
                return 'Mala';
            default:
                return value;
            }
        }

        if (col.field === 'facturado') {
            switch (value) {
            case '0':
                return 'No';
            case '1':
                return 'Sí';
            default:
                return 'No';
            }
        }

        if (col.field === 'duracion') {
            const fin = moment(tareaFito.hora_fin, 'HH:mm');
            const inicio = moment(tareaFito.hora_inicio, 'HH:mm');

            if (!inicio.isValid() || !fin.isValid()) {
                return '';
            }

            const duracion = fin.subtract(inicio.get('hours'), 'hours').subtract(inicio.get('minutes'), 'minutes').format('HH:mm');
            return duracion;
        }

        if (Utils.isNumber(value) && (col.field !== 'id')) {
            if ( col.field !== 'finca' ) {
                if (col.field === 'litros' && environment.features.showTareasMto){
                    return Utils.decimalFormat((value || '').replace(',', '.'), 4, '.', ',');
                }
                else if (col.field === 'litros' && environment.appName === 'onda'){
                    return Utils.decimalFormat((value || '').replace(',', '.'), 0, '.', ',');
                }
                else{
                    return Utils.decimalFormat((value || '').replace(',', '.'), 2, '.', ',');
                }
            } 
        }

        return value;
    }

    public formatDate(date: string) {
        moment.locale('es');
        return moment(date, 'DD/MM/YYYY').format('LL');
    }

    public getFinPlazoSeguridad() {
        let mayor = 0;
        
        if (this.receta.tratamiento && this.receta.tratamiento.linea) {
            for (const linea of this.receta.tratamiento.linea) {
                if (linea.producto && linea.producto.ps && (parseInt(linea.producto.ps ?? '', 10) > mayor)) {
                    mayor = +linea.producto.ps;
                }
            }
        }
        const fechaFin = moment(this.receta.fecha_fin, 'DD/MM/YYYY');
        fechaFin.add(mayor, 'days');
        return fechaFin.isValid() ? fechaFin.format('DD/MM/YYYY') : '';
    }

    public createNavigation(route: string) {
        this.router.navigate(['dashboard', route]);
    }


    public toggleRowValidation(event: InputSwitchChangeEvent, row: TareaFitoModel) {
        this.tareasApi.fitosanitariosPUT.safePerform({
            id: row.id,
            validado: event.checked              
        } as never).toPromise().then(() => {
            this.getRequest.safePerform();
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }


    public async downloadCsv() {
        this.form = new FitosanitariosFormDefinition(
            +FormType.EXPORT, 
            this.filtering.value as unknown as Record<string,string>, 
            null
        );
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as TareaFitoModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = this.form.formFields.name + '.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();      
    }

    public override updateFooter() {
        this.sum();
    }
      
    public override sum() {
        this.totalHoras = moment(new Date('October 1, 2014 00:00:00'));
        this.auxTotalHoras = moment(new Date('October 1, 2014 00:00:00'));
        let contador = 0;
        (this.filtering.value || []).forEach((tareas, index ) => {
      
            if ( tareas.data?.horas_totales != null ) {
         
                if (tareas.data.horas_totales.length > 0) {
                    contador++;
                    const horaMinuto = (tareas.data.horas_totales as string).split(':');
                    this.totalHoras = moment(this.totalHoras).add(horaMinuto[0], 'hours').add(horaMinuto[1], 'minutes');
                }
            }
      
            if ( index + 1 >= (this.filtering.value as TareaFitoModel[]).length ){
        
                let minutos = moment(this.totalHoras).format('mm');
            
                let differencia = moment(this.totalHoras).diff(this.auxTotalHoras);
            
                if ( minutos.toString().length === 0) {
                    minutos = '00';
                }
      
                if ( minutos.toString().length === 1) {
                    minutos = '0' + minutos.toString();
                }

                differencia = differencia / (1000 * 60 * 60);
                differencia = Math.abs(Math.floor(differencia));
      
                this.totalHoras = differencia + ':' + minutos;
            
                if ( contador === 0){
                    this.totalHoras = '00:00';
                }
      
            }
        
          
        });
      
        if ( contador === 0){
            this.totalHoras = '00:00';
        }
        this.filtering.filter();
    }
      
    public changeShowAll(){
        if (this.showAllTareas) {
            this.tareasApi.fitosanitariosGET.toPromise({p3: 1} as never).then(res => {
                this.filtering.setValue(res as TreeNode<TareaFitoModel>[]);
                return;
            }).catch (e => {
                console.log('catch en fiosanitariosGET: ' + e);
            }
            );
        } else {
            this.tareasApi.fitosanitariosGET.toPromise({p3: 0} as never).then(res => {
                this.filtering.setValue(res as TreeNode<TareaFitoModel>[]);
                return;
            }).catch (e => {
                console.log('catch en fitosanitariosGET: ' + e);
            }
            );
        }
        this.filtering.filter();
    }      

    public drawComplete(sigpad: SignaturePad) {
        this.modelSignature = sigpad.toDataURL('image/png');
    }
    public clearSigPad(sigpad: SignaturePad) {
        sigpad.clear();
        this.modelSignature = null;
    }

    private expandFormFields() {
    }

    private appendTable(model: TareaFitoModel) {
        const columns = [
            'Producto', 
            'Uso', 
            'Agente', 
            'C. Recomendada', 
            'C. Aplicada', 
            'F. Caducidad'
        ];
    
        if (this.env.showProductosMaxAplicacion) {
            columns.push('Nº máx aplicaciones', 'Nº Aplicaciones');
        }
    
        const data = model.tratamiento?.linea ?? [];
    
        const table: string[][] = [[]];
        const rowStyles: string[] = [];
        for (let row = 0; row <= data.length; row++) {
            if (row === 0) {
                table[row] = columns;
                rowStyles.push('');
            } else {
                const tratamiento = data?.[row-1];
                rowStyles.push(tratamiento?.producto.caducado ?? '');
                const rowData = [
                    (tratamiento?.ocultar_en_receta ? '<span class="ml-1 badge badge-secondary">Oculto</span>' : '') + 
                    (tratamiento?.producto.nombre ?? ''),
                    tratamiento?.uso_agente.uso ?? '',
                    tratamiento?.uso_agente.agente ?? '',
                    (this.decimalFormat(tratamiento?.cantidad_cuaderno, 2, '.', ',', 3) ?? '') + 
                            this.splitFormat(model.tratamiento?.uds_medida ?? '')[row-1],
                    (this.decimalFormat(tratamiento?.cantidad_real, 2, '.', ',', 3) ?? '') + 
                            this.splitFormat(model.tratamiento?.uds_medida ?? '')[row-1],
                    tratamiento?.producto?.vademecum?.fecha_caducidad ?? 'No figura',
                ];
                if (this.env.showProductosMaxAplicacion) {
                    rowData.push(
                        tratamiento?.producto?.num_maximo_aplicaciones?.toString() ?? 'No figura',
                        tratamiento?.producto?.veces_aplicado?.toString() ?? '0'
                    );
                }
                table[row] = rowData;
            }
        }
        return [table, rowStyles];
    }
}
